import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import kpisService from '../../services/kpisService';

const initialState = {
  myKpis: [],
  teamKpis: null,
  loading: false,
  error: null,
};

export const fetchMyKpis = createAsyncThunk(
  'kpis/fetchMyKpis',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await kpisService.getMyKpis(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error?.message || 'Failed to fetch KPIs');
    }
  }
);

export const fetchTeamKpis = createAsyncThunk(
  'kpis/fetchTeamKpis',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await kpisService.getTeamKpis(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error?.message || 'Failed to fetch team KPIs');
    }
  }
);

const kpisSlice = createSlice({
  name: 'kpis',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch my KPIs
      .addCase(fetchMyKpis.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyKpis.fulfilled, (state, action) => {
        state.loading = false;
        state.myKpis = action.payload;
      })
      .addCase(fetchMyKpis.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch team KPIs
      .addCase(fetchTeamKpis.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTeamKpis.fulfilled, (state, action) => {
        state.loading = false;
        state.teamKpis = action.payload;
      })
      .addCase(fetchTeamKpis.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = kpisSlice.actions;
export default kpisSlice.reducer;
